// AUTO-GENERATED SQL Builder (V40 Final) for ResaleTerm
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class ResaleTermSql {
  private ast = new SqlAst('ResaleTerm', 'resaleTerm');
  public readonly main: any = {};

  public guid: SqlField;
  public partnerVendorId: SqlField;
  public resellerVendorId: SqlField;
  public offeringId: SqlField;
  public offeringPackageId: SqlField;
  public eventSessionId: SqlField;
  public offeringItemId: SqlField;
  public price: SqlField;
  public isEnabled: SqlField;
  public createdByUser: SqlNavHybrid;
  public eventSession: SqlNavHybrid;
  public offering: SqlNavHybrid;
  public offeringItem: SqlNavHybrid;
  public offeringPackage: SqlNavHybrid;
  public partnerVendor: SqlNavHybrid;
  public resellerVendor: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('resaleTerm', 'guid', '', 'id', 'resaleTerm_guid');
    this.partnerVendorId = new SqlField('resaleTerm', 'partnerVendorId', '', 'id', 'resaleTerm_partnerVendor');
    this.resellerVendorId = new SqlField('resaleTerm', 'resellerVendorId', '', 'id', 'resaleTerm_resellerVendor');
    this.offeringId = new SqlField('resaleTerm', 'offeringId', 'offering', 'id', 'resaleTerm_offering');
    this.offeringPackageId = new SqlField('resaleTerm', 'offeringPackageId', 'offeringPackage', 'id', 'resaleTerm_offeringPackage');
    this.eventSessionId = new SqlField('resaleTerm', 'eventSessionId', 'eventSession', 'id', 'resaleTerm_eventSession');
    this.offeringItemId = new SqlField('resaleTerm', 'offeringItemId', 'offeringItem', 'id', 'resaleTerm_offeringItem');
    this.price = new SqlField('resaleTerm', 'price', '', 'id', 'resaleTerm_price');
    this.isEnabled = new SqlField('resaleTerm', 'isEnabled', '', 'id', 'resaleTerm_isEnabled');
    this.createdByUser = createNavHybrid('resaleTerm', 'resaleTerm_createdByUser', 'User');
    this.eventSession = createNavHybrid('resaleTerm', 'resaleTerm_eventSession', 'EventSession');
    this.offering = createNavHybrid('resaleTerm', 'resaleTerm_offering', 'Offering');
    this.offeringItem = createNavHybrid('resaleTerm', 'resaleTerm_offeringItem', 'OfferingItem');
    this.offeringPackage = createNavHybrid('resaleTerm', 'resaleTerm_offeringPackage', 'OfferingPackage');
    this.partnerVendor = createNavHybrid('resaleTerm', 'resaleTerm_partnerVendor', 'Vendor');
    this.resellerVendor = createNavHybrid('resaleTerm', 'resaleTerm_resellerVendor', 'Vendor');
    this.updatedByUser = createNavHybrid('resaleTerm', 'resaleTerm_updatedByUser', 'User');
    this.id = new SqlField('resaleTerm', 'id', '', 'id', 'resaleTerm_id');
    this.isDeleted = new SqlField('resaleTerm', 'isDeleted', '', 'id', 'resaleTerm_isDeleted');
    this.createdBy = new SqlField('resaleTerm', 'createdBy', '', 'id', 'resaleTerm_createdBy');
    this.createdDate = new SqlField('resaleTerm', 'createdDate', '', 'id', 'resaleTerm_createdDate');
    this.updatedBy = new SqlField('resaleTerm', 'updatedBy', '', 'id', 'resaleTerm_updatedBy');
    this.updatedDate = new SqlField('resaleTerm', 'updatedDate', '', 'id', 'resaleTerm_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:ResaleTermSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:ResaleTermSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:ResaleTermSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:ResaleTermSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:ResaleTermSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:ResaleTermSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:ResaleTermSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:ResaleTermSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:ResaleTermSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:ResaleTermSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
